import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import queryString from "query-string";

import history from "../../../../../history";
import { getExternalReports } from "../../../../../actions/workingTimeActions";

class ExternalList extends React.Component {
    constructor(props) {
        super(props);

        this.month = "";
        this.startMonth = "";
    }

    componentDidMount() {
        this.updateList();
    }

    componentDidUpdate() {
        this.updateList();
    }

    updateList = () => {
        this.queryParams = queryString.parse(history.location.search);
        this.month = this.queryParams.month === "previous" ? "previous" : "current";
        if (this.month !== this.startMonth) {
            this.startMonth = this.month;
            this.props.getExternalReports(this.month);
        }
    };

    formatValue = value => `${value < 0 ? "-" : ""}${Math.floor(Math.abs(value))}:${Math.round(60 * (Math.abs(value) % 1)) < 10 ? "0" : ""}${Math.round(60 * (Math.abs(value) % 1))}`;

    renderReports = () => this.props.reportList.map(unit => {
        return (
            <React.Fragment key={unit.externalOuID}>
                <div className="ui big unit header">
                    <div className="content">{unit.ouName}:</div>
                </div>
                {this.renderReport()}
                {unit.reports.map(report => {
                    return (
                        <div className="ui segment-wrapper" key={report.reportID}>
                            <div className="ui segment" onClick={() => this.linkTo(`/working-time/external/${report.userID}?month=${this.month}`)}>
                                {this.renderReport(report)}
                            </div>
                        </div>
                    );
                })}
            </React.Fragment>
        );
    });

    renderReport = (report = null) => {
        return (
            <div className={`ui${report ? "" : " header"} grid`}>
                <div className="four wide column">
                    <div className="content">{report ? `${report.lname} ${report.fname}` : "Nazwisko i imię"}</div>
                </div>
                <div className="four wide column">
                    <div className="content">{report ? report.standard : "Norma czasu pracy"}</div>
                </div>
                <div className="four wide column">
                    <div className="content">{report ? this.formatValue(report.workingTime) : "Łączny czas pracy"}</div>
                </div>
                <div className="four wide column">
                    <div className="content">{report ? this.formatValue(report.totalOvertime) : "Suma nadgodzin"}</div>
                </div>
            </div>
        );
    };

    linkTo = destination => history.push(destination);

    render() {
        return (
            <React.Fragment>
                <div className={`ui two item menu`}>
                    <Link to={`${history.location.pathname}?month=previous`} className={`${this.month === "previous" ? "active " : ""}item`}>
                        <div className="content">Poprzedni miesiąc</div>
                    </Link>
                    <Link to={`${history.location.pathname}?month=current`} className={`${this.month === "current" ? "active " : ""}item`}>
                        <div className="content">Obecny miesiąc</div>
                    </Link>
                </div>
                <div className="ui divider" />
                <div className="ui container">
                    <div className="ui large header">
                        <div className="content">{Object.keys(this.props.reportList).length ? `Raporty za okres od: ${this.props.reportList[Object.keys(this.props.reportList)[0]].reports[0].dateFrom} do: ${this.props.reportList[Object.keys(this.props.reportList)[0]].reports[0].dateTo}` : "Nie odnaleziono raportów"}</div>
                    </div>
                    {this.renderReports()}
                </div>
                <div className="ui divider" />
                <div className="footer content">
                    <p>Raporty generowane automatycznie, codziennie rano</p>
                </div>
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => ({ reportList: state.workingTime.externalList });

export default connect(mapStateToProps, { getExternalReports })(ExternalList);